"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgBricksFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M2 3c1.333.018 2 .684 2 2v1c0 1.333-.667 2-2 2V3zm0 7h4.143C7.38 10 8 10.667 8 12v1c0 1.333-.619 2-1.857 2H2v-5zm5.875-7h3.25C12.375 3 13 3.667 13 5v1c0 1.333-.625 2-1.875 2h-3.25C6.625 8 6 7.333 6 6V5c0-1.333.625-2 1.875-2zm4 7h3.25c1.25 0 1.875.667 1.875 2v1c0 1.333-.625 2-1.875 2h-3.25C10.625 15 10 14.333 10 13v-1c0-1.333.625-2 1.875-2zm-4 7h3.25c1.25 0 1.875.667 1.875 2v1c0 1.333-.625 2-1.875 2h-3.25C6.625 22 6 21.333 6 20v-1c0-1.333.625-2 1.875-2zm9 0h3.25c1.25 0 1.875.667 1.875 2v1c0 1.333-.625 2-1.875 2h-3.25C15.625 22 15 21.333 15 20v-1c0-1.333.625-2 1.875-2zM2 17c1.333.018 2 .684 2 2v1c0 1.333-.667 2-2 2v-5z' }))); };
exports.default = SvgBricksFilled;
//# sourceMappingURL=BricksFilled.js.map